import { Middleware } from '@nuxt/types';

const clearEventContext: Middleware = context => {
  context.store.dispatch('events/clearEventContext');
};

export default clearEventContext;
